import {
  Avatar,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  CheckboxProps,
  Divider,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  InputBase,
  Paper,
  Tooltip,
} from "@mui/material";
import { green } from "@mui/material/colors";
import React from "react";
import { maskContainsBit } from "../../../functions/bits.functions";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { ClickableTooltip } from "../../molecules";
import styled from "styled-components";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { Classes } from "../../../enums/classes.enum";

const ClassMask = () => {
  const [mask, setMask] = React.useState<number>(0);

  const handleChange = (e: any) => {
    const { value, checked: userChecked } = e.target;
    const bit = 1 << (value - 1);
    setMask(userChecked ? mask | bit : mask & ~bit);
  };

  const handleInput = (e: any) => {
    const { value: input } = e.target;
    const isValid = input >= 0 && input <= 1 << Classes.DRUID;
    setMask(isValid ? input : 0);
  };

  const resetMask = () => setMask(0);

  const classesList = Object.keys(Classes)
    .filter((value) => !isNaN(Number(value)) && Number(value) > 0)
    .map(Number);
  return (
    <Card sx={{ width: 384 }}>
      <CardHeader
        subheader="Class mask Calculator"
        avatar={
          <Avatar
            sx={{ marginLeft: "8px", bgcolor: green[500] }}
            aria-label="recipe"
          >
            C
          </Avatar>
        }
        action={
          <ActionsContainer>
            <Tooltip title="Reset" placement="top">
              <IconButton color="primary" component="span" onClick={resetMask}>
                <RestartAltIcon />
              </IconButton>
            </Tooltip>
          </ActionsContainer>
        }
        sx={{ "& > .MuiCardHeader-action": { alignSelf: "center" } }}
      />
      <CardContent sx={{ padding: "0 24px 24px 24px" }}>
        <InputAndCopy mask={mask} handleInput={handleInput} />

        <Grid container>
          {classesList.map((pClass) => (
            <Grid key={pClass} item xs={6}>
              <FormGroup>
                <FormControlLabel
                  checked={maskContainsBit(mask, 1 << (pClass - 1))}
                  control={<ClassCheckbox checkColor={green} value={pClass} />}
                  label={Classes[pClass]}
                  onChange={handleChange}
                />
              </FormGroup>
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default ClassMask;

const ActionsContainer = styled.div`
  display: flex;
  align-content: center;
  justify-content: center;

  & > span {
    width: 38px;
    height: 38px;

    & > img {
      width: 100%;
    }
  }
`;

const InputAndCopy = ({
  mask,
  handleInput,
}: {
  mask: number;
  handleInput: (e: any) => void;
}) => {
  return (
    <Paper
      variant="outlined"
      component="form"
      sx={{
        display: "flex",
        alignItems: "center",
        marginBottom: "16px",
        padding: "0 8px",
      }}
    >
      <InputBase
        size="small"
        sx={{ flex: 1, "& > input:first-child": { padding: 0 } }}
        value={mask}
        onChange={handleInput}
      />

      <Divider sx={{ height: 24, m: 0.5 }} orientation="vertical" />

      <ClickableTooltip title="Mask copié !">
        <IconButton
          color="primary"
          size="small"
          onClick={() => navigator.clipboard.writeText(String(mask))}
        >
          <ContentCopyIcon fontSize="small" />
        </IconButton>
      </ClickableTooltip>
    </Paper>
  );
};

const ClassCheckbox = ({
  checkColor,
  ...checkboxProps
}: { checkColor: Record<string, string> } & CheckboxProps) => (
  <Checkbox
    size="small"
    sx={{
      padding: "2px 8px",
      color: checkColor[500],
      "&.Mui-checked": {
        color: checkColor[600],
      },
    }}
    {...checkboxProps}
  />
);
